import {createContext, useContext} from 'react';

export interface IMonitorOption {
    uuid: string,
    label: string,
}

export interface IMonitorPicker {
    useSearch: (_term: string) => IMonitorOption[],
    useLabel: (_uuid: string) => string | undefined,
}

const MonitorPickerContext = createContext<IMonitorPicker | null>(null);

export const MonitorPickerProvider = MonitorPickerContext.Provider;

export const useMonitorPicker = (): IMonitorPicker => {
    const picker = useContext(MonitorPickerContext);

    if (!picker) {
        throw new Error('MonitorPickerProvider не найден выше по дереву');
    }

    return picker;
};
